import React from 'react';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import { useLocation } from 'react-router-dom';
import SpotlightTour from './SpotlightTour';

export const IDE_TOUR_KEY = 'ch_ide_tour_v1';
export const IDE_TOUR_START_EVENT = 'ch-start-ide-tour';
export const IDE_TOUR_COMPLETE_EVENT = 'ch-ide-tour-complete';

const steps = [
  {
    id: 'welcome',
    placement: 'center',
    eyebrow: 'Online IDE',
    title: 'Write, run, and share',
    body: 'A quick tour of the editor, Run, console, and fullscreen — so you can sketch code anytime.',
    cta: 'Show me around',
  },
  {
    id: 'toolbar',
    target: '[data-tour="ide-toolbar"]',
    placement: 'bottom',
    eyebrow: 'Controls',
    title: 'Run and tools',
    body: 'Switch language with the chips above the editor, hit Run to compile, or use share / reset / settings. Fullscreen shows language chips in the toolbar too.',
  },
  {
    id: 'editor',
    target: '[data-tour="ide-editor"]',
    placement: 'right',
    eyebrow: 'Write code',
    title: 'Monaco editor',
    body: 'Your draft saves on this device per language. Share generates a link others can open for a year.',
  },
  {
    id: 'console',
    target: '[data-tour="ide-console"]',
    placement: 'left',
    eyebrow: 'I/O',
    title: 'Test Cases & Test Result',
    body: 'Edit input under Test Cases, then Run. Use the arrow to minimize the panel; it reopens when you run. Results appear in Test Result.',
  },
  {
    id: 'finish',
    placement: 'center',
    eyebrow: "You're set",
    title: 'Ready to code',
    body: 'Replay this tour anytime with the help icon in the IDE toolbar. Happy hacking!',
    cta: 'Start coding',
  },
];

const IdeTour = () => {
  const location = useLocation();
  const active =
    location.pathname === '/ide' ||
    location.pathname === '/ide/' ||
    /^\/ide\/[^/]+\/?$/.test(location.pathname);

  return (
    <SpotlightTour
      steps={steps}
      storageKey={IDE_TOUR_KEY}
      startEvent={IDE_TOUR_START_EVENT}
      completeEvent={IDE_TOUR_COMPLETE_EVENT}
      active={active}
      autoStartDelay={1000}
      isReady={() =>
        Boolean(
          document.querySelector('[data-tour="ide-toolbar"]') &&
            document.querySelector('[data-tour="ide-console"]'),
        )
      }
      finishIcon={<CodeOutlinedIcon sx={{ fontSize: 14 }} />}
    />
  );
};

export default IdeTour;
